'use client'

const Error = () => {
  return (
    <div className="text-center mt-40">
      <h1 className="text-5xl text-blue">
        Tenim alguns problemes per mostrar aquesta informació
      </h1>
    </div>
  )
}

export default Error
